<template>

    <div id="wrapper">

			<form v-on:submit.prevent class="login-form">

				<img class="logo" src="~assets/img/Codium-PL-RGB-REV.png" alt="Codium" />

				<h1>Forgot Password.</h1>

				<p>Enter your email address below and you will be sent an email to reset your password.</p>

				<div class="form-group">
					<label class="control-label">Email Address</label>
                    <input 
                        v-model="email"
                        type="email" 
                        class="form-control" 
                        placeholder=""
                        required="" />
				</div><!-- /.form-group -->

                <ladda-button :type="''" :on-click="onReset" class="btn btn-login btn-block">Reset Password</ladda-button>

				<router-link :to="{name: 'auth.login'}" class="small">Back to login.</router-link>

			</form><!-- /.login-form -->

	</div><!-- /#wrapper -->

</template>

<script>
    import LaddaButton from 'components/form/input/ladda-button.vue'
    import { notify } from 'utils'

    export default {
        components: {
            LaddaButton
        },

        data: function () {
            return {
                email: ""
            }
        },
        methods: {
            onReset: function(e) {
              
                var that = this
                return client({ path: 'password/email', method:'POST', entity: {'email':this.email} }).then(
                  function (response) {
                    notify.success('Password reset email sent')
                    //router.push('/auth/login');
                  },
                  function (response) {
                    that.messages = []
                    if (response.status && response.status.code === 401) {

                        notify.error('Sorry, you provided invalid email')
                    } else if (response.status.code === 422) {
                        var firstValidationIssue = response.entity.errors[Object.keys(response.entity.errors)[0]];
                      
                        notify.error(firstValidationIssue)
                    }
                  }
                )
            },
            /**
             * If any fields return validation error they will notify us
             * @param msg
             */
            onValidationError: function (msg) {
                this.valid = false;
            },
        }
    }
</script>
